import { LayerGroup, WMSTileLayer } from 'react-leaflet'

export const KommuneplanLayer: React.FC = () => {
  return (
    <LayerGroup>
      <WMSTileLayer
        url="//nap.ft.dibk.no/services/wms/kommuneplaner/"
        layers="arealformal_kp"
        transparent={true}
        zIndex={500}
        format="image/png"
        pane="wms-pane"
      />
    </LayerGroup>
  )
}
